import React, { useState } from 'react';
import { AddonPanel } from '@storybook/components';
import { addons, types } from '@storybook/addons';
import { useChannel, useParameter } from '@storybook/api';
import Prism from 'prismjs';
import * as R from 'ramda';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-jsx';
import 'prismjs/themes/prism.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs/plugins/line-highlight/prism-line-highlight';
import 'prismjs/plugins/line-highlight/prism-line-highlight.css';
import { generateCodeSnippet } from './generate-code-snippet';

const CodeSnippetPanel = () => {
  const [selector, setSelector] = useState('');
  const children = useParameter('children', '');
  const [knobs, setKnobs] = useState({});
  const [initialValues, setInitialValues] = useState({});
  const [template, setTemplate] = useState('');

  useChannel({
    knobs: e => {
      setKnobs(e);
    },
    template: e => {
      setTemplate(e);
    },
    selector: e => {
      setSelector(e);
    },
    initialValues: e => {
      setInitialValues(e);
    },
  });

  const knobsWithoutDefault = R.pipe(
    R.toPairs(),
    R.filter(([name, value]) =>
      initialValues[name] !== undefined ? initialValues[name] !== value : true
    ),
    R.fromPairs()
  )(knobs);

  setTimeout(() => Prism.highlightAll(), 0);

  return (
    <React.Fragment>
      {!R.isEmpty(knobs) && selector ? (
        <pre className="line-numbers" style={{ background: '#fff' }}>
          <code className="language-html">
            {generateCodeSnippet(knobsWithoutDefault, selector, children)}
          </code>
        </pre>
      ) : (
        <pre className="line-numbers" style={{ background: '#fff' }}>
          <code className="language-html">{template.trim()}</code>
        </pre>
      )}
      {!selector && (
        <div style={{ margin: '10px', textAlign: 'center' }}>
          Error: Add parameter component and withSnippet decorator to Storybook
        </div>
      )}
    </React.Fragment>
  );
};

addons.register('code-snippet-addon', () => {
  addons.add('code-snippet-addon/panel', {
    title: 'Code Snippet',
    type: types.PANEL,
    render: ({ active, key }) => (
      <AddonPanel active={active} key={key}>
        <CodeSnippetPanel />
      </AddonPanel>
    ),
  });
});
